export class NewCase {
    issueCategoryList: any[];
    county_id: number;
    client_id: number;
    questionAndAnswer?: any[];
    case_id?: number;
    otherCaseDetails?: string;
}
